<template>
	<section class="validate-mail" id="validateEmail">

		<!-- TEXTO COM MAIS DE 24H do envio anterior ================ -->
		<div class="validate-mail__state" id="over__24" v-if="messageType === 'over24'" data-qa="email-validation-resend-ready-alert">
			<hgroup>
				<h1>{{ $t('validation.valid01.title') }}</h1>
				<p>{{ $t('validation.valid01.subtitle') }}</p>
			</hgroup>
			<p class="box__validateEmail" v-html="$t('validation.valid01.description')"></p>
		</div>


		<!-- TEXTO COM MENOS DE 24H do envio anterior ================ -->
		<div class="validate-mail__state" id="under__24" v-if="messageType === 'under24'" data-qa="email-validation-resend-cooldown-alert">
			<hgroup>
				<h1>{{ $t('validation.valid02.title') }}</h1>
				<p>{{ $t('validation.valid02.subtitle') }}</p>
			</hgroup>
			<p class="box__validateEmail" v-html="$t('validation.valid02.description')"></p>
		</div>


		<!-- Email EXPIRADO ================ -->
		<div class="validate-mail__state" id="expired" v-if="messageType === 'expired'" data-qa="email-validation-expired-alert">
			<hgroup>
				<h1>{{ $t('validation.valid03.title') }}</h1>
				<p>{{ $t('validation.valid03.subtitle') }}</p>
			</hgroup>
			<p class="box__validateEmail" v-html="$t('validation.valid03.description')"></p>
		</div>
		<!-- Email EXPIRADO ================ -->

		<!-- Frase feedback de reenvio de email -->
		<p class="box__validateEmail" v-html="$t('validation.feedback')" v-if="feedback" data-qa="email-validation-resend-success"></p>

		
		<!-- BLOCO 4: Feedback para e-mail já validado 
		###################################################################################################
		
		Para esse modulo exibir somente o botão de "voltar" e retirar o botão de reenviar e-mail de validação 
		
		================================================================================================  
		-->
		<div class="validate-mail__state" id="feedback-email-validated" v-if="messageType === 'validated'" data-qa="email-validation-confirmed-success">
			<hgroup>
				<h1>{{ $t('validation.valid04.title') }}</h1>
				<p>{{ $t('validation.valid04.subtitle') }}</p>
			</hgroup>
			<p class="box__validateEmail" v-html="$t('validation.valid04.description')"></p>
		</div>
		
		<!-- Botões de ação -->

		<div class="validate-mail__actions">
			<AppButton variant="secondary" @click="$emit('voltar')" data-qa="email-validation-back-button">{{ $t('buttons.voltar') }}</AppButton>
				<AppButton v-show="messageType === 'expired' || messageType === 'over24'" variant="primary"
					data-qa="email-validation-resend-button"
					:disabled="isResending"
					@click="$emit('reenviar')">{{ $t('buttons.resendValidationEmail') }}</AppButton>
		</div>

	</section>
</template>

<script>
import AppButton from '@/components/ui/AppButton.vue'

export default {
	name: 'ValidateMail',
	components: {
		AppButton,

	},
	props: {
		messageType: {
			type: String,
			required: true, // 'over24', 'under24', 'expired', 'validated'
		},
		feedback: {
			type: Boolean,
			required: true, //  'feedback'
		},
		isResending: {
			type: Boolean,
			default: false
		}
	},
	mounted() {

	},
	watch: {

	},
	methods: {

	},
}
</script>

<style lang="sass" scoped>
.validate-mail
	display: flex
	flex-direction: column
	gap: 1.25rem
	text-align: center

	&__state
		display: flex
		flex-direction: column
		gap: 1.25rem

	hgroup
		display: flex
		flex-direction: column
		gap: 0.5rem

		h1
			margin: 0
			font-size: clamp(1.75rem, 5vw, 2.25rem)
			font-weight: 700
			text-wrap: balance
			color: var(--lg-dark-gray-200)

		p
			margin: 0
			font-size: 1.0625rem
			font-weight: 500
			text-wrap: balance
			color: var(--lg-mid-gray-200)

	.box__validateEmail
		margin: 0
		padding: 0.875rem 1rem
		border: 1px solid var(--lg-light-gray-300)
		border-radius: 0.875rem
		background: var(--lg-light-gray-100)
		font-size: 1rem
		line-height: 1.5
		text-wrap: balance
		color: var(--lg-dark-gray-200)

	&__actions
		display: flex
		flex-wrap: wrap
		justify-content: center
		gap: 1rem
		margin-top: 0.75rem
</style>
